import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/beeswarm/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/beeswarm/';

class BeeswarmService {

  getBeeswarm(playerId, teamId, seasonId, radarId, compareSeasonIds) {
    return axios.get(`${API_URL}player/${playerId}/team/${teamId}/season/${seasonId}/radar/${radarId}/compare-seasons/${compareSeasonIds}`, 
      playerId, teamId, seasonId, radarId, compareSeasonIds)
    .then((response) => {
      return response.data;
    })
  }

  getBeeswarmByCategory(playerId, teamId, seasonId, radarId, categoryId, compareSeasonIds) {
    return axios.get(`${API_URL}player/${playerId}/team/${teamId}/season/${seasonId}/radar/${radarId}/category/${categoryId}/compare-seasons/${compareSeasonIds}`, 
      playerId, teamId, seasonId, radarId, categoryId, compareSeasonIds)
    .then((response) => {
      return response.data;
    })
  }

  getTeamBeeswarm(teamId, seasonId, radarId, compareSeasonIds) {
    return axios.get(
      API_URL + 'team/' + teamId + '/season/' + seasonId + '/radar/' + radarId + '/compare-seasons/' + compareSeasonIds
    )
    .then((response) => {
      return response.data;

    })
  }

  getTeamBeeswarmByCategory(teamId, seasonId, radarId, categoryId, compareSeasonIds) {
    return axios.get(
      API_URL + 'team/' + teamId + '/season/' + seasonId + '/radar/' + radarId + '/category/' + categoryId + '/compare-seasons/' + compareSeasonIds
    )
    .then((response) => {
      return response.data;

    })
  }

}

export default new BeeswarmService();
